module.exports = __webpack_public_path__ + "img/goto-icon.53ce4e1c.svg";